import { PolicyMessageInfo } from '@pulseops/common'
import React from 'react'
type TaskDetailContextData = {
  policyMessageInfo: PolicyMessageInfo | undefined | null
}
const defaultValues: TaskDetailContextData = {
  policyMessageInfo: undefined
}
export const TaskDetailContext = React.createContext<TaskDetailContextData>(defaultValues) 